import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';
import { T } from '../tiles';

/**
 * The town, seen from above: school grounds (north), the main street, the
 * convenience store and the park (middle), and the neighbourhood (south).
 * East of the school lies the new district: sports centre with courts,
 * the shopping mall, and the riding stables.
 */
const TW = 92;
const b = new MapBuilder(TW, 60, 'g');

// --- School grounds -----------------------------------------------------------
b.fill(0, 0, TW, 1, 'h').fill(0, 0, 1, 21, 'h').fill(55, 0, 1, 21, 'h').fill(TW - 1, 0, 1, 60, 'h');
b.building(14, 1, 28, 6, { roof: 'U', wall: 'B', window: 'w', roofRows: 4, doors: [13, 14], windows: [2, 3, 6, 7, 10, 17, 20, 21, 24, 25] });
b.fill(22, 7, 12, 14, 's'); // plaza in front of the school
b.fill(2, 9, 18, 11, 't').fill(4, 11, 14, 7, 'F'); // running track around the field
b.fill(20, 13, 2, 3, 's');
b.fill(37, 10, 4, 2, 'G').fill(49, 10, 4, 2, 'G').fill(37, 17, 4, 2, 'G');
b.fill(46, 15, 7, 5, 's'); // paved half-court in the south-east corner of the yard
b.fill(34, 14, 20, 1, 'p').fill(44, 9, 2, 11, 'p'); // courtyard paths
b.fill(0, 21, 56, 1, 'f').fill(25, 21, 6, 1, 's'); // fence + gate

// --- Main street ----------------------------------------------------------------
b.fill(0, 22, TW, 1, 's').fill(0, 23, TW, 4, 'r').fill(0, 24, TW, 1, 'l').fill(0, 27, TW, 1, 's');
b.fill(26, 23, 4, 4, '=').fill(71, 23, 4, 4, '=');

// --- Convenience store ------------------------------------------------------------
b.building(3, 29, 12, 6, { roof: 'R', wall: 'B', window: 'w', roofRows: 3, doors: [5, 6], windows: [1, 2, 3, 8, 9, 10], awning: true });
b.fill(3, 35, 13, 2, 's').fill(15, 28, 2, 9, 's');

// --- Park ---------------------------------------------------------------------------
b.fill(18, 37, 37, 1, 'p').fill(27, 28, 2, 19, 's');
b.fill(38, 30, 12, 5, '~');
for (const [x, y] of [[38, 30], [49, 30], [38, 34], [49, 34]]) b.set(x, y, 'g');
b.fill(43, 30, 1, 5, 'y'); // wooden footbridge across the pond
b.fill(20, 40, 6, 4, 'S');
b.fill(31, 30, 4, 2, 'G').fill(31, 42, 5, 2, 'G').fill(50, 40, 4, 3, 'G').fill(5, 40, 6, 3, 'G');

// --- Neighbourhood -------------------------------------------------------------------
b.fill(0, 47, 56, 1, 'h').fill(18, 47, 2, 1, 'p').fill(38, 47, 2, 1, 'p');
b.fill(18, 38, 2, 21, 'p').fill(38, 48, 2, 10, 'p');
b.building(3, 48, 12, 6, { roof: 'Y', wall: 'K', window: 'v', roofRows: 4, doors: [5], windows: [2, 3, 8, 9] });
b.building(22, 48, 14, 6, { roof: 'R', wall: 'B', window: 'w', roofRows: 4, doors: [6, 7], windows: [2, 3, 10, 11] });
b.building(42, 48, 12, 6, { roof: 'U', wall: 'K', window: 'v', roofRows: 4, doors: [6], windows: [2, 3, 9] });
b.fill(28, 54, 2, 4, 's').fill(8, 54, 1, 4, 'p').fill(48, 54, 1, 4, 'p');
b.fill(24, 55, 3, 2, 'G').fill(31, 55, 3, 2, 'G');
b.fill(0, 58, TW, 1, 's').fill(0, 59, TW, 1, 'h');

// --- East district: sports centre, courts ------------------------------------------------
b.building(60, 2, 26, 7, { roof: 'U', wall: 'B', window: 'w', roofRows: 4, doors: [12, 13], windows: [2, 3, 6, 7, 18, 19, 22, 23] });
b.fill(70, 9, 6, 13, 's');
b.fill(58, 11, 11, 9, 'c'); // tennis court
b.fill(78, 11, 11, 9, 'S'); // beach volleyball court
b.fill(56, 21, 35, 1, 'f').fill(70, 21, 6, 1, 's');
// --- Shopping mall ---------------------------------------------------------------------------
b.building(60, 29, 29, 9, { roof: 'Y', wall: 'B', window: 'w', roofRows: 4, doors: [13, 14, 15], windows: [2, 3, 4, 6, 7, 8, 20, 21, 22, 24, 25, 26], awning: true });
b.fill(58, 38, 33, 5, 's').fill(71, 28, 4, 1, 's');
b.fill(57, 43, 34, 3, 'G');
// --- Riding stables ----------------------------------------------------------------------------
b.fill(56, 47, 35, 1, 'h').fill(72, 47, 2, 1, 'p').fill(72, 46, 2, 1, 'p');
b.fill(58, 49, 30, 1, 'f').fill(58, 57, 30, 1, 'f').fill(58, 49, 1, 9, 'f').fill(87, 49, 1, 9, 'f');
b.fill(72, 49, 2, 1, 'p').fill(72, 50, 2, 8, 'p').fill(72, 57, 2, 1, 'p');
b.building(77, 50, 9, 4, { roof: 'R', wall: 'K', window: 'v', roofRows: 2, doors: [], windows: [2, 6] });
b.fill(60, 52, 8, 3, 'G');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });
const tree = (kind: Decor['kind'], tx: number, ty: number): Decor => ({
  kind,
  ...at(tx, ty),
  solid: { x: px(tx) - 6, y: px(ty) - 6, w: 12, h: 6 },
});
const lamp = (tx: number, ty: number): Decor => ({ kind: 'lamp', ...at(tx, ty), solid: { x: px(tx) - 2, y: px(ty) - 3, w: 4, h: 3 } });

/** Decor anchored at a fractional tile, with an optional centred collision box (`sw`×`sh` px). */
const dc = (kind: Decor['kind'], tx: number, ty: number, o: { w?: number; h?: number; variant?: number; sw?: number; sh?: number } = {}): Decor => ({
  kind,
  x: Math.round(px(tx)),
  y: Math.round(px(ty)),
  ...(o.w !== undefined ? { w: o.w } : {}),
  ...(o.h !== undefined ? { h: o.h } : {}),
  ...(o.variant !== undefined ? { variant: o.variant } : {}),
  ...(o.sw ? { solid: { x: Math.round(px(tx) - o.sw / 2), y: Math.round(px(ty) - (o.sh ?? 4)), w: o.sw, h: o.sh ?? 4 } } : {}),
});
/** Static passer-by (`xm_person`): look 0-15 (4, 9, 14 elders; 3, 10 kids), facing 0 down / 1 up / 2 left / 3 right. */
const person = (tx: number, ty: number, look: number, facing = 0): Decor => dc('xm_person', tx, ty, { variant: look * 4 + facing });
/** Ground paint (drawn with the structures, static): top-left anchored. */
const paint = (kind: Decor['kind'], tx: number, ty: number, w: number, h: number, variant = 0): Decor => ({ kind, x: Math.round(px(tx)), y: Math.round(px(ty)), w, h, variant, wall: true });
/** Utility poles along a row: each one strings its cables to the next. Variant bits: 1 transformer, 4 red plate. */
const poles = (ty: number, xs: number[], variants: Record<number, number> = {}): Decor[] =>
  xs.map((tx, i) => dc('tw_pole', tx, ty, { w: i < xs.length - 1 ? 2 * (px(xs[i + 1]) - px(tx)) : 0, variant: variants[i] ?? 0, sw: 4, sh: 3 }));
/** Arcade (騎樓) in front of a house `w` px wide: pillars every 64 px plus the east end (mirrors `arcadePillars`). */
const arcade = (tcx: number, w: number, variant: number): Decor[] => {
  const cx = px(tcx), y = px(55);
  const xs: number[] = [];
  for (let x = cx - w / 2; x < cx + w / 2 - 6; x += 64) xs.push(x);
  xs.push(cx + w / 2 - 6);
  return [{ kind: 'tw_arcade', x: cx, y, w, variant }, ...xs.map((x): Decor => ({ kind: 'tw_solid', x: x + 3, y, solid: { x, y: y - 4, w: 6, h: 4 } }))];
};

const decor: Decor[] = [
  // --- School grounds: flagpole, gate, bike sheds, notice board, students in groups ---------------
  tree('pine', 2, 3), tree('pine', 5, 5), tree('pine', 9, 3), tree('pine', 46, 4), tree('pine', 50, 3), tree('pine', 53, 6),
  tree('cherry', 37, 10), tree('cherry', 53, 10), tree('cherry', 37, 19), tree('cherry', 53, 19),
  { kind: 'flowerbed', ...at(24, 9), solid: { x: px(23), y: px(9) - 8, w: 32, h: 8 } },
  { kind: 'flowerbed', ...at(32, 9), solid: { x: px(31), y: px(9) - 8, w: 32, h: 8 } },
  dc('tw_flagpole', 30.1, 8.7, { sw: 16, sh: 5 }),
  dc('tw_gate', 28, 22, { w: 96 }),
  dc('tw_bikeShed', 24, 13, { w: 56, sw: 60, sh: 8 }),
  dc('tw_bikeShed', 24, 16.2, { w: 56, sw: 60, sh: 8 }),
  dc('tw_noticeBoard', 32, 12.3, { sw: 42, sh: 6 }),
  dc('tw_recycle', 31, 14.9, { sw: 28, sh: 5 }),
  dc('planter', 33.2, 15.4, { sw: 28, sh: 6 }),
  dc('tw_banner', 22.4, 11, { variant: 1 }), dc('tw_banner', 33.6, 11, { variant: 0 }),
  dc('xy_pigeons', 27.5, 11.6, { variant: 2 }),
  paint('tw_emblem', 28, 13.5, 44, 44), paint('tw_hopscotch', 23.2, 19.2, 9, 45),
  person(24.3, 19.4, 0, 3), person(25.4, 19.8, 5, 2), person(23.4, 20.2, 10, 0),
  person(31.4, 16.9, 2, 2), person(32.7, 16.5, 7, 3), person(32.1, 18.0, 12, 1),
  { kind: 'booth', ...at(32.5, 20), solid: { x: px(31) + 4, y: px(20) - 10, w: 24, h: 10 } },
  // Yard: a banyan, benches, a pergola, the half-court and a pick-up game.
  dc('xy_banyan', 41, 12.2, { sw: 14, sh: 6 }),
  dc('tw_sit', 36, 13.3, { variant: 16 + 1, sw: 26, sh: 6 }),
  dc('tw_pergola', 49.5, 9.2, { w: 56, sw: 60, sh: 8 }),
  dc('hoop', 49, 15.3, { sw: 8, sh: 4 }),
  paint('tw_court', 46.1, 15.1, 108, 76),
  person(48.2, 17.6, 3, 1), person(50.6, 18.6, 6, 2), person(47.2, 19.3, 11, 3),
  dc('tw_cones', 46.4, 20.6),
  dc('trashBin', 46.3, 13.7, { sw: 10, sh: 4 }),
  dc('xy_pigeons', 38.5, 12.5, { variant: 3 }),
  // Field: bleachers, cones, runners, a dog watching.
  { kind: 'goal', ...at(5, 15), solid: { x: px(4), y: px(15) - 6, w: 16, h: 6 } },
  { kind: 'hoop', ...at(16, 15), solid: { x: px(16) - 4, y: px(15) - 4, w: 8, h: 4 } },
  dc('tw_bleachers', 10.5, 8.95, { w: 88, sw: 96, sh: 10 }),
  dc('tw_cones', 3.2, 12.6),
  person(7.6, 9.95, 1, 3), person(14.2, 19.7, 8, 2), person(18.6, 13.2, 11, 1),
  dc('tw_dog', 17.6, 11.6, { variant: 1 | 4 }),
  dc('tw_banner', 19.6, 10.2, { variant: 1 }),
  dc('xy_bench', 10, 20.8, { sw: 26, sh: 6 }),
  // --- Main street: poles and cables, scooters along the kerb, lights, people waiting ---------------
  lamp(4, 22), lamp(14, 22), lamp(34, 22), lamp(46, 22), lamp(10, 28), lamp(22, 28), lamp(34, 28), lamp(48, 28),
  { kind: 'hydrant', ...at(40, 22), solid: { x: px(40) - 4, y: px(22) - 4, w: 8, h: 4 } },
  { kind: 'trashBin', ...at(24, 28), solid: { x: px(24) - 5, y: px(28) - 4, w: 10, h: 4 } },
  ...poles(22.95, [10.6, 19.6, 32.2, 43.6, 52.2, 58.5, 68.5, 81.5, 89], { 1: 1, 3: 4, 6: 1 }),
  dc('tw_pole', 16.6, 27.95, { variant: 2 | 1, h: 80, sw: 4, sh: 3 }),
  dc('tw_pole', 44.6, 27.95, { variant: 2, h: 80, sw: 4, sh: 3 }),
  dc('tw_pole', 66, 27.95, { variant: 2 | 4, h: 80, sw: 4, sh: 3 }),
  dc('tw_scooterRow', 17, 22.95, { w: 48, variant: 3, sw: 52, sh: 6 }),
  dc('tw_scooterRow', 11, 27.95, { w: 64, variant: 0, sw: 68, sh: 6 }),
  dc('tw_scooterRow', 41, 27.95, { w: 48, variant: 1, sw: 52, sh: 6 }),
  dc('tw_scooterRow', 65.5, 27.95, { w: 64, variant: 2, sw: 68, sh: 6 }),
  dc('trafficLight', 30.6, 22.95, { sw: 3, sh: 2 }), dc('trafficLight', 25.3, 27.95, { sw: 3, sh: 2 }),
  dc('trafficLight', 75.4, 22.95, { sw: 3, sh: 2 }), dc('trafficLight', 70.3, 27.95, { sw: 3, sh: 2 }),
  person(12.6, 22.95, 4, 3), person(41.4, 22.9, 1, 0), person(42.3, 22.95, 3, 0), person(35.3, 22.95, 14, 0), person(38.9, 22.95, 5, 0),
  person(22.6, 27.95, 9, 2), person(32.9, 27.9, 8, 1), person(49.6, 27.95, 13, 2),
  dc('tw_scooter', 31.8, 27.95, { variant: 16 | 2 }),
  paint('tw_drain', 12.1, 26.75, 12, 4), paint('tw_drain', 37, 23, 12, 4), paint('tw_drain', 47.5, 26.75, 12, 4), paint('tw_drain', 62, 23, 12, 4),
  paint('tw_roadPaint', 30.2, 26.1, 30, 13, 0), paint('tw_roadPaint', 21.9, 23.1, 30, 13, 0),
  paint('tw_roadPaint', 8, 23.1, 16, 14, 1), paint('tw_roadPaint', 50, 25.1, 16, 14, 1), paint('tw_roadPaint', 60, 23.1, 16, 14, 1), paint('tw_roadPaint', 84, 25.1, 16, 14, 1),
  paint('tw_roadPaint', 16, 23.2, 10, 14, 2), paint('tw_roadPaint', 36, 25.2, 10, 14, 2),
  paint('tw_roadPaint', 25.6, 23.1, 3, 30, 3), paint('tw_roadPaint', 30.2, 25.1, 3, 30, 3), paint('tw_roadPaint', 70.6, 23.1, 3, 30, 3), paint('tw_roadPaint', 75.2, 25.1, 3, 30, 3),
  paint('tw_roadPaint', 31, 23, px(14), 1.4, 4), paint('tw_roadPaint', 56, 23, px(15), 1.4, 4),
  paint('tw_roadPaint', 31, 26.9, px(20), 1.4, 5), paint('tw_roadPaint', 2, 26.9, px(22), 1.4, 5),
  // --- Corner store: lit sign band, scooters, vending machines, a sleeping dog, a cat on the awning ---
  dc('tw_storeSign', 9, 32.05, { w: 184 }),
  dc('tw_scooterRow', 5, 36.95, { w: 40, variant: 4, sw: 44, sh: 6 }),
  dc('xy_vending', 12.7, 36.9, { sw: 28, sh: 6 }),
  dc('tw_dog', 14.4, 36.95, { variant: 0 }),
  dc('tw_cat', 12.5, 32.95, { h: 2, variant: 0 }),
  dc('planter', 3.3, 35.4, { sw: 28, sh: 6 }),
  dc('tw_postbox', 17.4, 33.2, { sw: 20, sh: 5 }),
  // The empty lot behind the store is a vegetable garden, like so many in Taiwan.
  dc('tw_vegPlot', 6.5, 46.3, { w: 80, h: 40, sw: 84, sh: 44 }),
  dc('tw_roofShed', 10.5, 46.2, { w: 28, variant: 0, sw: 30, sh: 8 }),
  dc('tw_sit', 12.8, 46.6, { variant: 32 | 64 | 14, sw: 8, sh: 4 }),
  // Breakfast stall by the park entrance, with its queue; a juice cart on the other side.
  dc('tw_breakfast', 19.3, 29.7, { sw: 42, sh: 14 }),
  person(18.3, 30.7, 0, 1), person(19.4, 30.95, 10, 1), person(17.2, 30.9, 4, 3),
  dc('xy_banyan', 24, 30.4, { sw: 14, sh: 6 }),
  dc('tw_cart', 30.6, 28.95, { variant: 0, sw: 30, sh: 12 }),
  person(31.7, 29.9, 7, 2),
  // --- Park: koi pond with a footbridge, pavilion, pergola, exercise gear, flowers --------------------
  tree('tree', 24, 34), tree('tree', 33, 34), tree('tree', 53, 45),
  tree('tree', 46, 43), tree('tree', 35, 45), tree('cherry', 31, 40), tree('tree', 3, 39), tree('tree', 13, 44),
  tree('pine', 1, 30), tree('tree', 52, 36), tree('tree', 40.5, 44.5),
  { kind: 'bushDeco', ...at(22, 37), solid: { x: px(22) - 8, y: px(37) - 5, w: 16, h: 5 } },
  { kind: 'slide', ...at(24, 42), solid: { x: px(23) + 2, y: px(42) - 8, w: 28, h: 8 } },
  { kind: 'trashBin', ...at(30, 38), solid: { x: px(30) - 5, y: px(38) - 4, w: 10, h: 4 } },
  lamp(26, 37), lamp(36, 40), lamp(18, 45),
  dc('tw_koi', 44, 35, { w: 184, h: 72 }),
  dc('tw_bridgeRail', 43.5, 35, { h: 80 }),
  dc('tw_pavilion', 52, 33.7, { sw: 56, sh: 18 }),
  dc('tw_pergola', 23.5, 46.4, { w: 56, sw: 60, sh: 8 }),
  dc('tw_exercise', 49.6, 45.4, { variant: 0, sw: 12, sh: 4 }), dc('tw_exercise', 51.6, 45.6, { variant: 1, sw: 12, sh: 4 }), dc('tw_exercise', 47.6, 45.3, { variant: 2, sw: 12, sh: 4 }),
  person(50.4, 46.3, 4, 1), person(46.9, 46.2, 14, 1),
  dc('flowerbed', 31, 36.7, { sw: 32, sh: 8 }), dc('flowerbed', 48, 36.7, { sw: 32, sh: 8 }), dc('flowerbed', 38.5, 38.7, { sw: 32, sh: 8 }),
  dc('planter', 29.9, 38.6, { sw: 28, sh: 6 }),
  dc('tw_sit', 50.5, 36.7, { variant: 4 | 16, sw: 26, sh: 6 }),
  dc('tw_dog', 34.6, 41.6, { variant: 1 | 2 }),
  dc('xy_pigeons', 46.5, 38.8, { variant: 5 }),
  // --- Neighbourhood: arcades, rooftop tanks and sheds, the land-god temple, old men at chess ---------
  ...arcade(9, 192, 0), ...arcade(29, 224, 1), ...arcade(48, 192, 2),
  dc('tw_waterTank', 12.6, 50.7, { variant: 0 }), dc('tw_roofShed', 7, 51.2, { w: 36, variant: 1 | 4 }),
  dc('tw_waterTank', 33.6, 50.6, { variant: 1 }), dc('tw_roofShed', 26, 51.2, { w: 40, variant: 2 | 8 }),
  dc('tw_waterTank', 44.6, 50.5, { variant: 1 }), dc('tw_roofShed', 49.5, 51.2, { w: 40, variant: 1 | 2 | 4 | 8 }),
  dc('tw_waterTank', 12.6, 31.5, { variant: 1 }), dc('tw_roofShed', 6.5, 31.6, { w: 32, variant: 2 }),
  dc('tw_waterTank', 16, 4.5, { variant: 1 }), dc('tw_waterTank', 39.5, 4.5, { variant: 1 }), dc('tw_roofShed', 36, 4.6, { w: 40, variant: 2 | 4 }),
  dc('tw_waterTank', 62, 5.5, { variant: 1 }), dc('tw_waterTank', 83.5, 5.5, { variant: 0 }),
  dc('tw_waterTank', 62, 32.5, { variant: 1 }), dc('tw_waterTank', 86.5, 32.5, { variant: 1 }), dc('tw_roofShed', 70, 32.6, { w: 44, variant: 1 | 2 | 4 }),
  dc('tw_scooter', 24.6, 54.95, { variant: 1 | 32 }), dc('tw_scooter', 34.2, 54.95, { variant: 3 | 8 }),
  dc('tw_scooterRow', 44.6, 54.95, { w: 36, variant: 5, sw: 40, sh: 6 }),
  dc('pottedPlant', 23, 54.9, { sw: 12, sh: 5 }), dc('pottedPlant', 34.9, 54.9, { sw: 12, sh: 5 }), dc('pottedPlant', 4.6, 54.9, { sw: 12, sh: 5 }), dc('pottedPlant', 52.6, 54.9, { sw: 12, sh: 5 }),
  dc('tw_sit', 36.9, 52.9, { variant: 32 | 9, sw: 8, sh: 4 }),
  dc('xy_bicycle', 40.8, 52.6, { variant: 2 }), dc('pottedPlant', 41.2, 50.6, { sw: 12, sh: 5 }),
  dc('xy_bicycle', 16.1, 52.6, { variant: 1 }), dc('tw_scooter', 16.6, 50.7, { variant: 2 | 8 }), dc('laundryRack', 20.6, 50.7, { sw: 20, sh: 4 }),
  dc('tw_temple', 4.6, 57.4, { sw: 60, sh: 26 }),
  dc('xy_banyan', 13.6, 57.5, { sw: 14, sh: 6 }),
  dc('xm_chessTable', 11.4, 57.9, { sw: 30, sh: 8 }),
  dc('tw_banner', 7.3, 57.3, { variant: 2 }),
  tree('pine', 36, 56), tree('tree', 41, 57), tree('pine', 55, 56),
  { kind: 'bushDeco', ...at(25, 55), solid: { x: px(25) - 8, y: px(55) - 5, w: 16, h: 5 } },
  dc('tw_dog', 50.6, 55.1, { variant: 2 | 8 }),
  dc('tw_cat', 10, 47.95, { h: 5, variant: 0 }), dc('tw_cat', 43.5, 47.95, { h: 5, variant: 4 | 2 }),
  lamp(20, 58), lamp(40, 58),
  person(6, 58.95, 1, 3), person(7, 58.95, 10, 3), person(26.2, 58.9, 8, 2), dc('tw_scooter', 28, 58.95, { variant: 16 | 4 }), person(45, 58.95, 4, 2),
  ...poles(58.95, [3, 13, 24.3, 36, 50], { 1: 1, 3: 4 }),
  // --- East district --------------------------------------------------------------------------------
  lamp(62, 22), lamp(80, 22), lamp(62, 28), lamp(80, 28), lamp(64, 42), lamp(84, 42), lamp(70, 58), lamp(84, 58),
  tree('pine', 57, 4), tree('pine', 88, 4), tree('pine', 89, 13), tree('tree', 58, 44), tree('tree', 89, 44), tree('cherry', 66, 44), tree('cherry', 82, 44),
  tree('tree', 57, 56), tree('tree', 89, 52),
  { kind: 'tennisNet', x: px(63) + 8, y: px(16) },
  { kind: 'volleyNet', x: px(83) + 8, y: px(16) },
  { kind: 'fountain', x: px(74), y: px(41) },
  { kind: 'signSports', x: px(69), y: px(21) },
  { kind: 'marketGate', x: px(1) + 4, y: px(28) + 2, w: 40 },
  { kind: 'stationArrow', x: px(88), y: px(22) },
  dc('tw_scooterRow', 82.5, 22.95, { w: 56, variant: 6, sw: 60, sh: 6 }),
  person(60.2, 13.2, 12, 3), person(67.6, 18.6, 1, 2), person(80.2, 13.2, 6, 3), person(87, 18.6, 13, 2),
  dc('xy_bench', 69.2, 10.5, { sw: 26, sh: 6 }),
  dc('xy_taxi', 68, 42.6, { variant: 0, sw: 36, sh: 10 }),
  person(70.1, 40.2, 5, 0), person(71, 40.6, 10, 0), person(78.6, 39.6, 2, 2), person(84, 42.1, 14, 3),
  dc('planter', 63.5, 38.6, { sw: 28, sh: 6 }), dc('planter', 85, 38.6, { sw: 28, sh: 6 }),
  dc('tw_cart', 80, 40.6, { variant: 1, sw: 30, sh: 12 }),
  dc('xy_pigeons', 76.5, 41.6, { variant: 4 }),
  dc('tw_sit', 88.5, 40.6, { variant: 2 | 16, sw: 26, sh: 6 }),
  dc('xy_bench', 61.5, 48.7, { sw: 26, sh: 6 }), person(66, 48.8, 3, 0), person(67.1, 48.8, 1, 0),
  dc('tw_dog', 84.5, 56.2, { variant: 1 | 4 }),
  // Festival decorations (only during their week).
  ...[[20, 37], [29, 37], [34, 37], [41, 37], [47, 37], [53, 37], [25, 22], [31, 22]].map(([tx, ty], i) => ({ kind: 'festLanterns' as const, x: px(tx), y: px(ty), variant: i, fest: 'lantern' })),
  ...[[20, 37], [34, 37], [47, 37], [53, 37]].map(([tx, ty], i) => ({ kind: 'festLanterns' as const, x: px(tx), y: px(ty), variant: i + 10, fest: 'moon' })),
  ...[[27, 54], [30, 54], [7, 54], [10, 54], [47, 54], [50, 54], [5, 35], [12, 35]].map(([tx, ty], i) => ({ kind: 'festCouplet' as const, x: px(tx), y: px(ty), variant: i, fest: 'newYear' })),
  ...[[29, 37], [41, 37], [50, 37]].map(([tx, ty], i) => ({ kind: 'festLanterns' as const, x: px(tx), y: px(ty), variant: i + 20, fest: 'newYear' })),
  { kind: 'signMall', x: px(70), y: px(28) + 2 },
  { kind: 'parkedCar', x: px(61), y: px(41), solid: { x: px(60), y: px(40) + 4, w: 30, h: 10 }, variant: 0 },
  { kind: 'parkedCar', x: px(86), y: px(41), solid: { x: px(85), y: px(40) + 4, w: 30, h: 10 }, variant: 1 },
  { kind: 'hay', x: px(76), y: px(55), solid: { x: px(75) + 4, y: px(55) - 6, w: 22, h: 6 } },
  { kind: 'trough', x: px(66), y: px(56), solid: { x: px(65), y: px(56) - 5, w: 26, h: 5 } },
];

/** Night lights besides the street lamps: shop sign, temple and pavilion lanterns, the evening stall. */
const extraLights = [
  { x: px(9), y: px(32) - 10, r: 96, color: '255,245,215' },
  { x: px(4.6) - 28, y: px(57.4) - 37, r: 44, color: '255,110,70' },
  { x: px(4.6) + 28, y: px(57.4) - 37, r: 44, color: '255,110,70' },
  { x: px(4.6), y: px(57.4) - 24, r: 36, color: '255,170,90' },
  { x: px(52), y: px(33.7) - 34, r: 48, color: '255,120,70' },
  { x: px(19.3) + 21, y: px(29.7) - 30, r: 40, color: '255,140,80' },
];

export const town: MapDef = {
  id: 'town',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: false,
  theme: { wallFace: '#e9dcc3', wallLight: '#f6ecd8', wainscot: '#8a5c3a', wallTop: '#3a2a20' },
  doors: [
    { tiles: [[27, 6], [28, 6]], to: 'school', arrive: { x: px(19), y: px(28) - 2, facing: 'up' } },
    { tiles: [[8, 34], [9, 34]], to: 'store', arrive: { x: px(7), y: px(8) + 6, facing: 'up' } },
    { tiles: [[28, 53], [29, 53]], to: 'home', arrive: { x: px(12), y: px(15) + 6, facing: 'up' } },
    { tiles: [[72, 8], [73, 8]], to: 'sports', arrive: { x: px(16), y: px(20) + 4, facing: 'up' } },
    { tiles: [[73, 37], [74, 37], [75, 37]], to: 'mall', arrive: { x: px(20) + 8, y: px(22) + 4, facing: 'up' } },
    { tiles: [[8, 53]], to: 'grandma', arrive: { x: px(7), y: px(9) + 6, facing: 'up' } },
    { tiles: [[48, 53]], to: 'bo', arrive: { x: px(7), y: px(9) + 6, facing: 'up' } },
    { tiles: [[91, 22], [91, 23], [91, 24], [91, 25], [91, 26], [91, 27]], to: 'station', arrive: { x: px(1) + 10, y: px(4) + 8, facing: 'right' } },
    { tiles: [[0, 22], [0, 23], [0, 24], [0, 25], [0, 26], [0, 27], [0, 28]], to: 'market', arrive: { x: px(2), y: px(11), facing: 'right' } },
  ],
  decor,
  areas: [
    { key: 'tennis', rect: { x: px(57), y: px(10), w: px(13), h: px(11) } },
    { key: 'volley', rect: { x: px(77), y: px(10), w: px(13), h: px(11) } },
    { key: 'sportsCenter', rect: { x: px(56), y: 0, w: px(36), h: px(22) } },
    { key: 'mall', rect: { x: px(56), y: px(28), w: px(36), h: px(19) } },
    { key: 'stable', rect: { x: px(56), y: px(47), w: px(36), h: px(13) } },
    { key: 'field', rect: { x: 0, y: px(8), w: px(21), h: px(13) } },
    { key: 'yard', rect: { x: px(34), y: px(8), w: px(22), h: px(13) } },
    { key: 'schoolGate', rect: { x: 0, y: 0, w: px(56), h: px(22) } },
    { key: 'street', rect: { x: 0, y: px(22), w: px(56), h: px(6) } },
    { key: 'store', rect: { x: 0, y: px(28), w: px(17), h: px(10) } },
    { key: 'park', rect: { x: 0, y: px(28), w: px(56), h: px(19) } },
    { key: 'neighborhood', rect: { x: 0, y: px(47), w: px(56), h: px(13) } },
  ],
  lights: [...decor.filter((d) => d.kind === 'lamp').map((d) => ({ x: d.x, y: d.y - 26, r: 64, color: '255,224,150' })), ...extraLights],
};

/** Lanes cars drive along (pixel y of the car's wheels) — west→east and east→west. */
export const CAR_LANES = [
  { y: px(24) + 2, dir: 1 },
  { y: px(26) + 6, dir: -1 },
];
export const CROSSWALK = { x0: px(26), x1: px(30) };
export const TOWN_SIZE = { w: b.w * T, h: b.h * T };
export const TOWN_TILES_W = TW;
